import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 根据产品id获取字段
export const getProduct = (data: any) =>
  request.post('/erp/web/youka/product_material/selectProductExtFiled', data)

// erp
// 获取产品下拉列表
export const getProductListerp = (data: any, headers: any = undefined) =>
  request.post('/erp/web/youka/shop_product/erpSelectListDown', data, {
    headers: { ...headers, 'Content-Type': ContentTypeEnum.FORM_DATA }
  })

// 新增进件
export const addIncomeerp = (data: any) =>
  request.post('/erp/retailIntoInfo/erp/insertInto', data, jsonHeaderConfig)

// 进件绑卡通知
export const sendBindNoticeerp = (data: any) =>
  request.post('/erp/retailIntoInfo/sendBindNotice', data, jsonHeaderConfig)

// 修改进件
export const updateIncomeerp = (data: any) =>
  request.post('/erp/retailIntoInfo/erp/updateInto', data, jsonHeaderConfig)

// 进件列表
export const getIncomeerp = (data: any) =>
  request.post('/erp/retailIntoInfo/erp/pageQuery', data, jsonHeaderConfig)

// 状态
export const getIntoStatus = () =>
  request.post('/erp/retailIntoInfo/erp/intoStatusCount', null, jsonHeaderConfig)

// 进件详情
export const getIncomeDetailerp = (data: any) =>
  request.post('/erp/retailIntoInfo/erp/queryDetail', data, jsonHeaderConfig)

// 申请提款
export const drawApplyerp = (data: any) =>
  request.post('/erp/retailIntoInfo/erp/drawApply', data, jsonHeaderConfig)

// 申请提款详情
export const drawApplyDetailerp = (data: any) =>
  request.post('/erp/retailIntoInfo/erp/drawApplyDetail', data, jsonHeaderConfig)

// 获取子表数据
export const getSubTableerp = (data: any) =>
  request.post('/erp/retailIntoInfo/erp/queryDetailRelate', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// bpm
// 获取产品下拉列表
export const getProductListbpm = (data: any, headers: any = undefined) =>
  request.post('/erp/web/youka/shop_product/bpmSelectListDown', data, {
    headers: { ...headers, 'Content-Type': ContentTypeEnum.FORM_DATA }
  })

// 新增进件
export const addIncomebpm = (data: any) =>
  request.post('/erp/retailIntoInfo/bpm/insertInto', data, jsonHeaderConfig)

// 修改进件
export const updateIncomebpm = (data: any) =>
  request.post('/erp/retailIntoInfo/bpm/updateInto', data, jsonHeaderConfig)

// 进件列表
export const getIncomebpm = (data: any) =>
  request.post('/erp/retailIntoInfo/bpm/pageQuery', data, jsonHeaderConfig)

// 状态
export const getIntoStatusBpm = () =>
  request.post('/erp/retailIntoInfo/bpm/intoStatusCount', null, jsonHeaderConfig)

// 进件详情
export const getIncomeDetailbpm = (data: any) =>
  request.post('/erp/retailIntoInfo/bpm/queryDetail', data, jsonHeaderConfig)

// 申请提款
export const drawApplybpm = (data: any) =>
  request.post('/erp/retailIntoInfo/bpm/drawApply', data, jsonHeaderConfig)

// 申请提款详情
export const drawApplyDetailbpm = (data: any) =>
  request.post('/erp/retailIntoInfo/bpm/drawApplyDetail', data, jsonHeaderConfig)

// 获取子表数据
export const getSubTablebpm = (data: any) =>
  request.post('/erp/retailIntoInfo/bpm/queryDetailRelate', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 查合同
export const getContact = (data: any) =>
  request.post('/erp/retailContractManage/queryByBusinessForm', data, jsonHeaderConfig)

// 进件审批查合同
export const getApproveInfo = (data: any) =>
  request.post('/erp/retailIntoInfo/getApproveInfo', data, {
    headers: { 'Content-Type': ContentTypeEnum.FORM_DATA }
  })

// 根据手机号查信息-主表
export const getConsumerInfo = (data: any) =>
  request.post('/erp/web/youka/consumerInfo/getConsumerInfo', data)

// 根据手机号查信息-子表
export const getSubConsumerInfo = (data: any) =>
  request.post('/erp/web/youka/consumerInfo/getSubConsumerInfo', data, undefined, {
    ignoreCancelToken: true
  })

// 删除子表
export const deleteConsumerInfo = (data: any) =>
  request.post('/erp/web/youka/consumerInfo/deleteConsumerInfo', data)

// 失焦保存信息
export const updateInfoBlur = (data: any) =>
  request.post('/erp/web/youka/consumerInfo/unfocusedUpdate', data, jsonHeaderConfig)

// erp 进件审批状态统计
export const getErpIncomeApproveCount = () =>
  request.post('/erp/retailIntoInfo/erp/flowStatusCount', null, jsonHeaderConfig)

// bpm 进件审批状态统计
export const getBpmIncomeApproveCount = () =>
  request.post('/erp/retailIntoInfo/bpm/flowStatusCount', null, jsonHeaderConfig)

// erp 进件授信状态统计
export const getErpIncomeCreditCount = () =>
  request.post('/erp/retailIntoInfo/erp/creditStatusCount', null, jsonHeaderConfig)

// bpm 进件授信状态统计
export const getBpmIncomeCreditCount = () =>
  request.post('/erp/retailIntoInfo/bpm/creditStatusCount', null, jsonHeaderConfig)
